import React from 'react'

type Props = {
  width?: string
  height?: string
  color?: string
}

function Success({ width = '24', height = '24', color = '#62AF83' }: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle
        cx='12'
        cy='12'
        r='12'
        fill='#62AF83'
      />
      <path
        d='M16 9L10.5 14.5L8 12'
        stroke='white'
        strokeWidth='1.5'
        strokeLinejoin='round'
        strokeLinecap='round'
      />
    </svg>
  )
}

export default Success
